import actionCreator from "../shared/services/actionCreator";

export const applicantExamTimeLeftAction = actionCreator(
  "applicantExamTimeLeftAction",
);

export const challengeTimeLeftAction = actionCreator("challengeTimeLeftAction");

export const applicantTickAction = actionCreator("applicantTickAction");
